import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import ContentWidth from "components/ContentWidth"

const Grid = ({ gridData }) => {
  const gridItems = gridData.grid.map(item => (
    <GridItem variation={gridData.variation}>
      <Icon alt={item?.icon?.altText} src={item.icon.sourceUrl} />
      <Header>{item.header}</Header>
      <Body>{item.bodyCopy}</Body>
    </GridItem>
  ))
  return (
    <ContentWidth>
      <Wrapper variation={gridData.variation}>{gridItems}</Wrapper>
    </ContentWidth>
  )
}

const Body = styled.p`
  ${text.bodyMd};
`
const Header = styled.h5`
  ${text.h5};
  margin-bottom: 0.972vw;

  ${media.fullWidth} {
    margin-bottom: 14px;
  }

  ${media.tablet} {
    margin-bottom: 1.367vw;
  }

  ${media.mobile} {
    ${text.h4};
    margin-bottom: 3.271vw;
  }
`
const Icon = styled.img`
  margin-bottom: 1.111vw;
  width: 5vw;
  height: 5vw;

  ${media.fullWidth} {
    margin-bottom: 16px;
    width: 72px;
    height: 72px;
  }

  ${media.tablet} {
    margin-bottom: 1.563vw;
    width: 7.031vw;
    height: 7.031vw;
  }

  ${media.mobile} {
    margin-bottom: 3.738vw;
    width: 16.822vw;
    height: 16.822vw;
  }
`
const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.variation === "3x3" ? "24.583vw" : "18.056vw")};

  ${media.fullWidth} {
    width: ${props => (props.variation === "3x3" ? "354px" : "260px")};
  }

  ${media.tablet} {
    width: ${props => (props.variation === "3x3" ? "27.6vw" : "28vw")};
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  gap: ${props =>
    props.variation === "3x3" ? "2.778vw 2.083vw" : "2.778vw 1.944vw"};

  ${media.fullWidth} {
    gap: ${props => (props.variation === "3x3" ? "40px 30px" : "40px 40px")};
  }

  ${media.tablet} {
    gap: ${props =>
      props.variation === "3x3" ? "3.906vw 2.148vw" : "3.906vw 3.418vw"};
  }

  ${media.mobile} {
    gap: 9.346vw;
  }
`
export default Grid
